import React, { FC } from 'react';
import { Content } from 'src/components/content';
import { Error } from 'src/components/Error';
import { Header } from 'src/components/header/header';
import { Page } from 'src/components/page';

export const UNAUTHORISED_PAGE_ROUTE = '/unauthorised';

export const UnauthorisedPage: FC = () => {
  return (
    <Page data-type="page" data-page={UNAUTHORISED_PAGE_ROUTE}>
      <Header />

      <Content>
        <Error
          heading="Unauthorised"
          text="You do not yet have access to LOVE, please contact your administrator"
          showButton={false}
        />
      </Content>
    </Page>
  );
};
